import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

export default class {
  // Set inital vars
  constructor(el) {
    this.el = el;
    this.blockId = el.getAttribute('data-block-id')
  }

  // Initilize Module
  init() {

    // try waiting a few seconds before initializing the carousel
    // this is an attempt to get the images rendered in the DOM
    // before calculating size for the carousel
    let scope = this;
    setTimeout(function() {
      scope.ImageCarousel();
    }, 2000);
  }

  ImageCarousel() {
    let selector = '.swiper' + this.blockId;

    this.slider = new Swiper(this.el.querySelector(selector), {
      slidesPerView: 1,
      loop: true,
      speed: 600,
      autoHeight: true,
      spaceBetween: 20,
      direction: 'horizontal',

      pagination: {
        el: '.swiper-pagination' + this.blockId,
        clickable: true,
      },

       navigation: {
        nextEl: `.swiper-next-${this.blockId}`,
        prevEl: `.swiper-previous-${this.blockId}`
      },

      mousewheel: {
        invert: true,
      },

      breakpoints: {
        // when window width is >= 500
        500: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          slidesPerGroupAuto: true,
          autoHeight: false
        },
      }
    });
  }
}
